"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.form.title.edit': '编辑步骤',
    'step.form.title.add': '添加步骤',
    'step.form.back': '返回',
    'step.form.title.label': '标题',
    'step.form.title.placeholder': '步骤标题',
    'step.form.order.label': '顺序',
    'step.form.order.placeholder': '步骤顺序',
    'step.form.isShared.label': '共享步骤',
    'step.form.profession.label': '职业',
    'step.form.profession.placeholder': '选择职业',
    'step.form.description.label': '描述',
    'step.form.description.placeholder': '描述',
    'step.form.questions.title': '问题',
    'step.form.questions.add': '添加问题',
    'step.form.questions.remove': '删除',
    'step.form.questions.empty': '尚未添加问题。点击"添加问题"开始。',
    'step.form.questions.order': '问题',
    'step.form.submit.update': '更新步骤',
    'step.form.submit.create': '创建步骤',
};
